<template>
  <div class="popup-wrapper" v-if="visible">
    <div class="popup">
      <img src="@/assets/imgs/common/close.png" alt="닫기" class="close" @click="clickCloseModal" />
      <p class="title-text">클래스 상세정보</p>
      <table class="class-info">
        <tbody>
          <tr class="border-line" v-for="(classItem, classIndex) in classInfo" :key="'class' + classIndex">
            <td class="class-label">{{ classItem.title }}</td>
            <td class="class-text">{{ classItem.text }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "@vue/runtime-core";
import _ from "lodash";
export default {
  emits: ["closeModal"],
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
    classInfo: {
      type: Object,
      required: false,
      default() {
        return [];
      },
    },
  },
  setup(_, context) {
    const clickCloseModal = () => {
      context.emit("closeModal");
    };
    const infoList = ref([]);

    onMounted(() => {});

    return {
      clickCloseModal,
      infoList,
    };
  },
};
</script>

<style lang="scss" scoped>
.popup-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color: $black, $alpha: 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .popup {
    display: flex;
    flex-direction: column;
    background-color: $white;
    border-radius: 14px;
    padding: 20px 42px 47px 42px;
    width: 500px;
    max-width: 500px;

    .class-info {
      border: 1px solid $gray-dde0e4;
    }

    .border-line {
      border-bottom: 2px solid rgba($color: $black, $alpha: 0.1);
    }

    .class-label {
      width: 20%;
      background-color: $gray-dde0e4;
      padding: 20px 0;
      color: $black;
      text-align: center;
    }

    .class-text {
      padding: 20px;
    }

    .title-text {
      font-size: 30px;
      font-weight: $bold;
      text-align: center;
      margin-bottom: 40px;
    }

    .close {
      width: 19px;
      align-self: flex-end;
      margin-bottom: 25px;
      cursor: pointer;
    }

    .name-wrapper {
      display: flex;
      flex-direction: column;
      gap: 9px 0;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid rgba($color: $black, $alpha: 0.07);

      label {
        font-weight: $bold;
      }

      input {
        font-size: 16px;
        color: $black;
        padding: 15px;
        background-color: rgba($color: $gray-dde0e4, $alpha: 0.5);
        border-radius: 8px;

        &::placeholder {
          color: #949494;
        }
      }
    }
  }
}
</style>
